import { axios } from './axios';
import {_url} from '../utils/http.util';
export default {
    get: (url, payload = {}) => {
        const totalUrl = url + querify(payload);
        return axios.get(_url(totalUrl));
    },
    post: (url, payload = {}) => {
        return axios.post(_url(url), payload);
    },
    put: (url, payload) => {
        return axios.put(_url(url), payload);
    },
    delete: (url, payload) => {
        const totalUrl = url + querify(payload);
        return axios.delete(_url(totalUrl));
        // return axios.post(totalUrl);
    },
    querify: (params) => querify(params)

}

// Adicionar el parametro de cuId => current user id para hacer trazabilidad de las acciones
const makeParams = payload => !payload.hasOwnProperty('cuId') && !!store.getters.user ? {...payload, cuId: store.getters.user.id}: payload;

const querify = (params) => {
    if(!params || !Object.keys(params).length) return '';
    const arrParams = [];
    Object.keys(params).map(key => (typeof params[key] !== 'undefined' && params[key] !== '' && params[key] !== null) && arrParams.push(paramValue(key, params)));
    const union = !!arrParams.length? '?': '';
    const queryString = union + arrParams.join('&');
    return queryString;


}
const paramValue = (key, data) => {
    if(Array.isArray(data[key])){
        return `${key}=${data[key].join(',')}`
    }
    return `${key}=${data[key]}`;
}
